const money = (amount, currency = 'USD') => ({ amount, currency });

const option = (id, title, priceLabel, oneTime, recurring = []) => ({
	id,
	title,
	requiredLabel: 'Included',
	priceLabel,
	descriptionHtml: `<p>${title} details</p><ul><li>Discovery</li><li>Delivery</li></ul>`,
	badge: id === 'starter' ? 'Best value' : null,
	priceSummary: { oneTime: oneTime ? money(oneTime) : null, recurring },
});

const baseDefinition = (mode, optionIds) => ({
	presentation: {
		eyebrow: 'Proposal',
		title: 'Choose your package',
		descriptionHtml: '<p>Select the best fit.</p>',
		addOnsLabel: 'Optional enhancements',
		paymentChoiceLabel: 'How you would like to pay',
		totalLabel: 'Amount due',
		layout: 'CARDS',
		detailsInitiallyExpanded: false,
	},
	selectionRules: {
		mode,
		minimumSelections: mode === 'CHOOSE_MANY' ? 1 : null,
		maximumSelections: mode === 'CHOOSE_MANY' ? 2 : null,
	},
	options: [
		option('starter', 'Starter', 'one time', '1000.00'), option('growth', 'Growth', 'monthly', null, [{ label: 'Support', amount: money('100.00'), cadenceLabel: 'monthly' }]),
	],
	addOns: [
		{
			id: 'global-training',
			title: 'Training',
			required: false,
			priceLabel: 'one time',
			descriptionHtml: '<p>Additional support for your project.</p>',
			availability: { scope: 'ALL_OPTIONS', optionIds: [] },
			application: 'ONCE_PER_AGREEMENT',
			quantity: { adjustable: true, minimum: 1, maximum: 5, step: 1, defaultValue: 1 },
			priceSummary: { oneTime: money('150.00'), recurring: [] },
		},
		{
			id: 'growth-audit',
			title: 'Growth audit',
			required: false,
			priceLabel: 'one time',
			descriptionHtml: null,
			availability: { scope: 'SPECIFIC_OPTIONS', optionIds: ['growth'] },
			application: 'ONCE_PER_AGREEMENT',
			quantity: { adjustable: false, minimum: 1, maximum: 1, step: 1, defaultValue: 1 },
			priceSummary: { oneTime: money('300.00'), recurring: [] },
		},
	],
	paymentChoices: [
		{ id: 'full', kind: 'PAY_IN_FULL', label: 'Pay in full', description: 'Save 5%', isDefault: true, discount: { kind: 'PERCENTAGE', value: '5' }, },
		{ id: 'installments', kind: 'INSTALLMENTS', label: 'Installments', description: 'Two payments', isDefault: false, discount: null,
			installments: {
				scheduledPayments: [
					{ id: 'due-1', label: 'First payment', triggerType: 'IMMEDIATE' },
					{ id: 'future-1', label: 'Final payment', triggerType: 'DELAY' },
				],
			}, },
	],
	defaultSelection: { optionIds, addOns: [], paymentChoiceId: 'full' },
});

export const packageOffer = (mode = 'CHOOSE_ONE', optionIds = ['starter']) => ({
	id: `offer-${mode.toLowerCase()}`,
	type: 'PackageOffer',
	commercialState: { canEditSelection: true, selectionLocked: false },
	acceptedSelection: null,
	definition: baseDefinition(mode, optionIds),
});

export const authoritativeQuote = (selection = { optionIds: ['starter'], addOns: [], paymentChoiceId: 'full' }) => ({
	quoteFingerprint: 'quote-fixture-1',
	agreementId: 'agreement-1',
	documentVersion: 'version-3',
	currency: 'USD',
	normalizedSelection: selection,
	paymentChoiceTotals: {
		originalSubtotal: money('1000.00'),
		subtotal: money('950.00'),
		tax: money('95.00'),
		total: money('1045.00'),
	},
	oneTime: {
		lines: [
			{ id: 'starter-line', label: 'Starter', quantity: 1, unitAmount: money('1000.00'), subtotal: money('1000.00'), discount: money('50.00'), tax: money('95.00'), total: money('1045.00'),
	},
		],
		subtotal: money('1000.00'),
		originalTotal: money('1100.00'), eligibleSubtotal: money('1000.00'), ineligibleSubtotal: money('0.00'), discount: money('50.00'), tax: money('95.00'), total: money('1045.00'),
	},
	dueToday: { lines: [{ id: 'due-1', label: 'First payment', category: 'ONE_TIME', amount: money('545.00') }], subtotal: money('500.00'), tax: money('45.00'), total: money('545.00'),
		originalTotal: money('545.00'),
		cardProcessingFee: money('16.86'),
		totalWithCardProcessingFee: money('561.86'), },
	futureInstallments: [
		{ id: 'future-1', label: 'Final payment', triggerLabel: 'On delivery', dueDate: null, amount: money('500.00'), tax: money('50.00'), total: money('550.00'),
		},
	],
	recurringSchedules: [
		{ id: 'support', label: 'Support',
			subtotal: money('90.91'),
			tax: money('9.09'), amount: money('100.00'), cadenceLabel: 'monthly', startsOn: null, nextChargeDate: null, firstPeriodDueToday: false, autoCharge: true,
		},
	],
	fulfillmentSummary: { projects: [{ id: 'project-1', name: 'Implementation', recurring: false, taskCount: 8 }] },
	collection: { mode: 'PAYMENT_INTENT', savePaymentMethod: true, autoChargeFuture: true },
	taxSummary: { label: 'Tax', rate: 10 },
	validation: { valid: true, errors: [], warnings: [] },
});
